export const getVisiblePages = (current, total) => {
  const pages = [];

  const showLeft = current > 3;
  const showRight = current < total - 2;

  pages.push(1);

  if (showLeft) pages.push("left-ellipsis");

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  for (let p = start; p <= end; p++) {
    pages.push(p);
  }

  if (showRight) pages.push("right-ellipsis");

  if (total > 1) pages.push(total);

  return pages;
};
